import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { motion } from "framer-motion";

const ItemTypes = {
  QUESTION: "question",
};

const DraggableQuestion = ({
  id,
  index,
  question,
  answer,
  moveQuestion,
  onChange,
  remove,
}) => {
  const ref = useRef(null);
  const dragHandleRef = useRef(null);

  const [, drop] = useDrop({
    accept: ItemTypes.QUESTION,
    hover(item) {
      if (item.index !== index) {
        moveQuestion(item.index, index);
        item.index = index;
      }
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.QUESTION,
    item: { id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref)); // Drop target applies to the whole item
  drag(dragHandleRef); // Drag applies only to the icon

  return (
    <div
      ref={ref}
      className={`flex gap-4 w-full items-center mt-4 bg-gray-200 p-4 shadow-lg rounded-lg ${
        isDragging ? "opacity-50" : "opacity-100"
      }`}
    >
      {/* Drag Handle */}
      <div
        ref={dragHandleRef}
        className="cursor-grab p-2 hover:bg-gray-300 rounded-lg"
      >
        <i className="fa fa-grip-vertical text-gray-600"></i>
      </div>

      <span className="text-gray-700 font-medium">{index + 1}.</span>
      <textarea
        placeholder="Enter question"
        value={question}
        onChange={(e) => onChange(index, "question", e.target.value)}
        className="w-1/2 px-4 py-2 border rounded-lg h-20 bg-gray-100"
      />
      <textarea
        placeholder="Enter answer"
        value={answer}
        onChange={(e) => onChange(index, "answer", e.target.value)}
        className="w-1/2 px-4 py-2 border rounded-lg h-20 bg-gray-100"
      />
      <motion.button
        onClick={() => remove(index)}
        className="flex justify-center items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <i className="fa fa-trash-can"></i>
        Remove
      </motion.button>
    </div>
  );
};

export default DraggableQuestion;
